export enum WorkspaceLayerTypes {
  PlannedExcavationZones = 'ExcavationZonePolygons',
  PlannedDumpZones = 'DumpZonesPolygons',
  SectionLines = 'SectionLines',
}

export enum WorkspaceZoneType {
  Excavation = 'Excavation',
  Dump = 'Dump',
  SectionLine = 'SectionLine',
}
